import { AquatecSystemApiEnum } from 'submodules/nerit-aquatec-sdk/common/AquatecSystemApiEnum'
import { HttpMethodEnum } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/enums/HttpMethodEnum'
import { RequestConfigTP } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/types/RequestConfigTP'
import { CollectionGridRequestDTO } from 'submodules/nerit-aquatec-sdk/services/collection-control/dtos/requests/CollectionGridRequestDTO'
import { CollectionStatusSaveRequestDTO } from 'submodules/nerit-aquatec-sdk/services/collection-control/dtos/requests/CollectionStatusSaveRequestDTO'
import { CollectionGridResponseDTO } from 'submodules/nerit-aquatec-sdk/services/collection-control/dtos/responses/CollectionGridResponseDTO'

export class CollectionControlRequests {

	public static CONTROLLER_ROOT = 'collection-control'
	public static GRID_EP = 'grid'
	public static SAVE_CELL_EP = 'save-cell'

	static grid = (dto: CollectionGridRequestDTO): RequestConfigTP<CollectionGridResponseDTO> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${CollectionControlRequests.CONTROLLER_ROOT}/${CollectionControlRequests.GRID_EP}`,
		method: HttpMethodEnum.GET,
		params: dto,
	})

	static saveCell = (dto: CollectionStatusSaveRequestDTO): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${CollectionControlRequests.CONTROLLER_ROOT}/${CollectionControlRequests.SAVE_CELL_EP}`,
		method: HttpMethodEnum.PUT,
		params: dto,
	})

}
